import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';


@Component({
  selector: 'app-blue-box-dialog',
  templateUrl: './blue-box-dialog.component.html',
  styleUrls: ['./blue-box-dialog.component.scss']
})
export class BlueBoxDialogComponent implements OnInit {
  dialogType = 'BusinessManager';
  dialogTitle: string;
  prettyType: string;

  constructor(private _matDialogRef: MatDialogRef<BlueBoxDialogComponent>,
              public _snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) data) {
    this.dialogType = data.dialogType;
    switch (this.dialogType) {
      case 'BusinessManager':
        this.dialogTitle = 'Edit This Business';
        this.prettyType = 'business';
        break;
      case 'FlyingClubManager':
        this.dialogTitle = 'Edit This Flying Club';
        this.prettyType = 'flying club';
        break;
      case 'ClaimManager':
        this.dialogTitle = 'Manage This Business';
        break;
      case 'ReportIssue':
        this.dialogTitle = 'Report An Issue';
        break;
    }
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  goToLink(url: string){
    window.open(url, '_blank');
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    this._matDialogRef.close(data);
  }
}
